import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

import {Flex, MenuGroup, MenuItem, Text, Icon} from '@spothero/ui';
import IconSparkle from '@spothero/icons/sparkle';

const navigationItemStyleProps = {
    color: 'black',
    borderColor: 'white',
    backgroundColor: 'white',
    paddingX: 4,
    paddingY: 2,
    fontWeight: 'semibold',
    borderRadius: 'base',
    fontSize: 'sm',
    _hover: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _active: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _focus: {
        boxShadow: 'outline',
        _hover: {
            boxShadow: 'none',
        },
    },
    _disabled: {
        color: 'gray.medium',
        cursor: 'not-allowed',
        _hover: {
            backgroundColor: 'white',
        },
    },
};

const NavigationMenuGroup = ({heading, submenu}) => {
    const menuGroupDataTestId = `MenuGroup${heading.replaceAll(' ', '')}`;

    return (
        <MenuGroup
            title={heading}
            paddingX={3.5}
            maxWidth="325px"
            data-testid={menuGroupDataTestId}
        >
            {submenu.map(
                (
                    {
                        label: submenuLabel,
                        subtitle,
                        route: submenuRoute,
                        isDisabled,
                        isNew,
                    },
                    index
                ) => {
                    const submenuDataTestId = `SubMenuItem${submenuLabel.replaceAll(
                        ' ',
                        ''
                    )}`;

                    return (
                        <MenuItem
                            key={index}
                            as={NavLink}
                            to={submenuRoute}
                            color="black"
                            isDisabled={isDisabled}
                            data-testid={submenuDataTestId}
                            {...navigationItemStyleProps}
                        >
                            <Flex>
                                <Text fontSize="sm">{submenuLabel}</Text>
                                {isNew && (
                                    <Flex
                                        fontSize="xs"
                                        fontWeight="semibold"
                                        marginLeft={2}
                                        backgroundColor="primary.default"
                                        color="white"
                                        width="fit-content"
                                        height={5}
                                        paddingX={2}
                                        paddingY={0}
                                        borderRadius="full"
                                        alignItems="center"
                                    >
                                        <Icon
                                            marginRight={1}
                                            as={IconSparkle}
                                            width={3}
                                            height={3}
                                        />
                                        New!
                                    </Flex>
                                )}
                            </Flex>
                            <Text fontSize="xs" fontWeight="light">
                                {subtitle}
                            </Text>
                        </MenuItem>
                    );
                }
            )}
        </MenuGroup>
    );
};

NavigationMenuGroup.propTypes = {
    heading: PropTypes.string.isRequired,
    submenu: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            subtitle: PropTypes.string,
            route: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool,
            isNew: PropTypes.bool,
        })
    ).isRequired,
};

export default NavigationMenuGroup;
